import Rellax from 'rellax';


const rellaxElements = document.querySelectorAll(".rellax");
const rellaxInstances = [];

rellaxElements.forEach(el => {
    const rellax = new Rellax(el, {
        breakpoints: [320, 768, 1024],
        relativeToWrapper: true,
        wrapper: el.parentElement.parentElement
    });
    rellaxInstances.push(rellax);
});

function refreshRellax () {
    rellaxInstances.forEach(rellax => {
        rellax.refresh();
    });
}

window.addEventListener("scroll", refreshRellax);
window.addEventListener("resize", refreshRellax);